import { Box, Button } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import Logo, {
  CaymanCountryLogoWithText,
  LogoContainerResponsive,
} from '@/components/Icon/Logo';
import { Form } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';
import {
  ContentContainer,
  ResponsiveMarginTopMessage,
} from '@/components/Layout/Page/Page.styled';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { isCaymanDomain } from '@/utils/domain';

export function FinishedPage() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());
  const theme = useTheme();

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        hasLogo: false,
        color: (theme: Theme) => theme.palette.overlay.forest.start,
        secondColor: (theme: Theme) => theme.palette.overlay.forest.end,
        children: (
          <>
            {isCaymanDomain ? (
              <CaymanCountryLogoWithText alt="Cayman Country Logo with Text" />
            ) : (
              <Logo />
            )}
          </>
        ),
      }}
      formContainerProps={{
        sx: {
          justifyContent: 'center',
          textAlign: 'center',
          [theme.breakpoints.up('lg')]: {
            justifyContent: 'unset',
            textAlign: 'left',
          },
        },
      }}
    >
      <ContentContainer>
        <LogoContainerResponsive>
          {isCaymanDomain ? (
            <CaymanCountryLogoWithText alt="Cayman Country Logo with Text" />
          ) : (
            <Logo />
          )}
        </LogoContainerResponsive>
        <ResponsiveMarginTopMessage>
          {t('createNewAccount.finished.thankYouMessage')}
        </ResponsiveMarginTopMessage>
      </ContentContainer>
      <Box width="100%">
        <Form>
          <Button onClick={onBackToSignIn}>
            {t('createNewAccount.finished.button.backToLogin')}
          </Button>
        </Form>
      </Box>
    </Page>
  );
}

export default FinishedPage;
